import { NoveltyRule } from '@/models/api/campaign/noveltyCampaign'
import { Novelty } from '@/models/novelty/novelty'
import { NoveltySelection } from './novelty-selection'

export class SkuSummary {
  constructor(
    public rule: NoveltyRule,
    public novelty: Novelty,
    public selection: NoveltySelection,
    private cartPrice: number
    ) {
  }

  get requiringPrice(): number {
    return this.rule.requiring_price
  }

  get maxCount(): number {
    return Math.min(
      this.rule.select_limit,
      this.novelty.maxSellCount,
      // Console運用担当者としては、ステータス=販売停止だが在庫>0の場合も、在庫=0相当の振る舞いを期待する。
      // https://github.com/my-color/front/issues/3362
      this.novelty.saleStatus.isOnSale ? this.novelty.stock : 0
    )
  }

  get priceBasedMaxCount(): number {
    const priceBasedLimit = Math.floor(this.cartPrice / this.requiringPrice)

    return Math.min(priceBasedLimit, this.maxCount)

  }

  get isOutOfStock(): boolean {
    return this.maxCount === 0
  }

  /**
   * If use has already put a novelty into the cart, a selection area should be shown,
   * even to set it to 0 when stock is empty.
   */
  get userCanChangeCount(): boolean {
    return this.selection.count !== 0 || this.maxCount !== 0
  }
}
